<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'
import Button from '@/common/Button.vue'

const props = defineProps({
    viewId: String
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Computed properties
const tableName = computed(() => viewStore.tableName || null)
const savedFilters = computed(() => viewStore.savedFilters || [])
const show = computed(() => savedFilters.value.length > 0)
const filters = computed(() => viewStore.filters || null)

const selectedFilter = computed(() => {
    if (!filters.value) return null
    const currentFiltersString = JSON.stringify(filters.value)
    return savedFilters.value.find(o => JSON.stringify(o.filters) === currentFiltersString) || null
})

const isAnySelected = computed(() => {
    return !!selectedFilter.value
})

// Methods
const isSelected = (targetFilters) => {
    if (!filters.value || !targetFilters) return false
    return JSON.stringify(targetFilters) === JSON.stringify(filters.value)
}

const loadSavedFilter = (name) => {
    viewStore.loadSavedFilter(name)
}

const deletedSavedFilter = (name) => {
    viewStore.deleteSavedFilter(name)
}
</script>

<template>
    <div v-if="show" class="dropdown pb-3 border-bottom">
        <!-- Added @click to guarantee Bootstrap's dropdown hook fires on your custom wrapper -->
        <Button data-bs-toggle="dropdown" class="btn-sm border dropdown-toggle">
            {{ selectedFilter ? selectedFilter.name : 'Saved filters' }}
        </Button>

        <div class="dropdown-menu">
            <!-- Swapped loop :key from index 'i' to unique 'o.name' for correct rendering on delete -->
            <div v-for="o in savedFilters" :key="o.name" @click="loadSavedFilter(o.name)" role="button"
                 class="dropdown-item pe-2 d-flex align-items-center" :class="{'active': isSelected(o.filters)}">
                <span class="flex-fill">{{ o.name }}</span>

                <button @click.stop="deletedSavedFilter(o.name)" class="ms-3 btn btn-sm btn-danger p-0 lh-1 rounded-5">
                    <i class="bi bi-x"/>
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.dropdown-item button {
    visibility: hidden;
}

.dropdown-item:hover button {
    visibility: visible;
}
</style>